import mutations from "./mutations"
import * as actions from "./actions";
import * as getters from "./getters";

let state = {
    date: null,
    days: null,
    element: null
}

export default {mutations, actions, state, getters}



// WEBPACK FOOTER //
// ./src/store/modules/hairRegimen/index.js